
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/offers/create",
      function () {
        return require("private-next-pages/offers/create.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/offers/create"])
      });
    }
  